import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_TODAY_APPOINTMENTS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetTodayAppointmentsPayload, GetTodayAppointmentsResult } from '../types/getTodayAppointments.types';

export const TAG_TODAY_APPOINTMENTS = 'getTodayAppointments';

export const getTodayAppointments = <T extends BuilderType>(builder: T) =>
  builder.query<GetTodayAppointmentsResult, GetTodayAppointmentsPayload>({
    providesTags: [TAG_TODAY_APPOINTMENTS],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_TODAY_APPOINTMENTS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetTodayAppointmentsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
